import React, {useState,useEffect, useRef} from 'react';

function UnderlineButton({buttonTitle, buttonLabel, clickHandler, disabled = false, customStyles = {}}) {

    const handleClick = (e) => {
        if(disabled===false && clickHandler !==undefined){
            clickHandler(e)
        }
    }

    useEffect(()=>{console.log({customStyles})}, [])
    return (
        <>
            {buttonTitle && (
                <div style={{height: 10, flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 12, display: 'flex', ...customStyles}}>
                    <div style={{justifyContent: 'flex-start', alignItems: 'flex-end', gap: 4, display: 'inline-flex'}}>
                        <div style={{color: '#707070', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '400', wordWrap: 'break-word'}}>{buttonTitle}</div>
                    </div>
                </div>
            )}
            <div onClick={e => handleClick(e)} style={{justifyContent: 'center', alignItems: 'center', gap: 8, display: 'inline-flex', cursor: 'pointer', ...customStyles}}>
                <div style={{paddingTop: 6, paddingBottom: 6, borderBottom: '2px #46C3B2 solid', justifyContent: 'center', alignItems: 'center', gap: 10, display: 'flex'}}>
                    <div style={{textAlign: 'center', color: '#46C3B2', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '700', wordWrap: 'break-word'}}>{buttonLabel}</div>
                </div>
            </div>
        </>
    )
}

export default UnderlineButton;
